import React, { FC } from 'react';
import { QueryResult } from 'react-query';

import { ResponsiveWrapper } from 'components/styled/Wrapper';
import Text from 'components/styled/Text';
import Button from 'components/styled/Button';

type Props = Pick<QueryResult<unknown, unknown>, 'error' | 'refetch'>;

const ErrorScreen: FC<Props> = ({ error, refetch }) => (
	<ResponsiveWrapper alignItems="flex-start" mt={4}>
		<Text color="text" fontSize="xl" fontWeight="bold" mt={3} mb={4} as="h2">
			Nastala chyba během získávání dat!
			{error ? ` (${(error as Error)?.message ?? 'unknown error'})` : ''}
		</Text>

		<Text>Prosím zkuste operaci znovu.</Text>

		<Button mt={3} onClick={() => refetch()}>
			Zkusit znovu
		</Button>
	</ResponsiveWrapper>
);

export default ErrorScreen;
